import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCotjjD37KmSrDbIwp2_ytmCQhWMmOzJqE",
  authDomain: "barbershop-talk-59143.firebaseapp.com", // You'll need to get this from Firebase Console
  projectId: "barbershop-talk-59143",
  storageBucket: "barbershop-talk-59143.firebasestorage.app",
  messagingSenderId: "28970285272",
  appId: "1:28970285272:ios:402077cf769ee3e335ffad"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);